import { s as l, _ as Z } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as m from "react";
import { s as v, c as t } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var d = (e) => /* @__PURE__ */ m.createElement(
  "svg",
  Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, e),
  /* @__PURE__ */ m.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ m.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ m.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.402 8 6.114 14.065.05A56.78 56.78 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017c-.008-.614 0-1.249.027-1.898L6.114 8 2.467 4.353a9.023 9.023 0 0 1 1.821-1.95Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ m.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031C15.035.015 15.518.004 16 0L8.472 7.529l-.708-.708 6.791-6.79ZM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772ZM.003 16v-.003L7.53 8.47l.707.708L1.414 16H.004Zm8.469-7.529.707-.707L16 14.586V16L8.472 8.471Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ m.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372c.112-.05.226-.097.342-.143C7.272.875 8.544.6 10 .4Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ m.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442a30.35 30.35 0 0 1 .424-2.125s.169-.803.663-1.875Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ m.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ m.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558c.09-.485.193-.972.308-1.458 0 0 .102-.487.38-1.208ZM28.5 12l.337 1.161H30l-.918.71.336 1.129-.918-.71-.918.678.336-1.097-.918-.71h1.133L28.5 12Zm-4 8 .337 1.161H26l-.918.71.336 1.129-.918-.71-.918.678.336-1.097-.918-.71h1.133L24.5 20Zm0-12 .337 1.161H26l-.918.71.336 1.129-.918-.71-.918.678.336-1.097-.918-.71h1.133L24.5 8Zm-4 5 .337 1.161H22l-.918.71.336 1.129-.918-.71-.918.678.336-1.097-.918-.71h1.133L20.5 13Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ m.createElement(
    "path",
    {
      fill: "#fff",
      d: "m28.837 13.161-.144.042.031.108h.113v-.15Zm1.163 0 .092.119.347-.269H30v.15Zm-.918.71-.092-.119-.082.063.03.099.144-.043ZM29.418 15l-.091.119.368.285-.133-.447-.144.043Zm-.918-.71.092-.118-.09-.07-.091.068.089.12Zm-.918.678-.144-.044-.133.434.366-.27-.09-.12Zm.336-1.097.144.044.03-.1-.082-.063-.092.119Zm-.918-.71v-.15h-.44l.348.269.092-.119Zm1.133 0v.15h.11l.033-.104-.143-.046Zm-3.296 8-.144.042.031.108h.113v-.15Zm1.163 0 .092.119.347-.269H26v.15Zm-.918.71-.092-.119-.082.063.03.099.144-.043ZM25.418 23l-.091.119.368.285-.133-.447-.144.043Zm-.918-.71.092-.118-.09-.07-.091.068.089.12Zm-.918.678-.144-.044-.133.434.366-.27-.09-.12Zm.336-1.097.144.044.03-.1-.082-.063-.092.119Zm-.918-.71v-.15h-.44l.348.269.092-.119Zm1.133 0v.15h.11l.033-.105-.143-.045Zm.704-12-.144.042.031.108h.113v-.15Zm1.163 0 .092.119.347-.269H26v.15Zm-.918.71-.092-.119-.082.063.03.099.144-.043ZM25.418 11l-.091.119.368.285-.133-.447-.144.043Zm-.918-.71.092-.118-.09-.07-.091.068.089.12Zm-.918.678-.144-.044-.133.434.366-.27-.09-.12Zm.336-1.097.144.044.03-.1-.082-.063-.092.119ZM23 9.161v-.15h-.44l.348.269.092-.119Zm1.133 0v.15h.11l.033-.104-.143-.046Zm-3.296 5-.144.042.031.108h.113v-.15Zm1.163 0 .092.119.347-.269H22v.15Zm-.918.71-.092-.119-.082.063.03.099.144-.043ZM21.418 16l-.091.119.368.285-.133-.447-.144.043Zm-.918-.71.092-.118-.09-.07-.091.068.089.12Zm-.918.678-.144-.044-.133.434.366-.27-.09-.12Zm.336-1.097.144.044.03-.1-.082-.063-.092.119Zm-.918-.71v-.15h-.44l.348.269.092-.119Zm1.133 0v.15h.11l.033-.104-.143-.046Zm8.223-2.12.337 1.162.288-.083-.337-1.162-.288.084Zm.48 1.27H30v-.3h-1.163v.3Zm1.072-.268-.918.71.183.237.919-.71-.184-.237Zm-.97.87.337 1.13.287-.086-.337-1.129-.287.086Zm.572.968-.918-.71-.184.238.919.71.183-.238Zm-1.099-.711-.918.677.178.241.918-.677-.178-.241Zm-.686.842.337-1.097-.287-.088-.337 1.097.287.088Zm.285-1.26-.918-.71-.184.238.919.71.183-.238Zm-1.01-.44h1.133v-.3H27v.3Zm1.276-.105.367-1.162-.286-.09-.367 1.161.286.09Zm-3.92 6.835.337 1.161.288-.084-.337-1.16-.288.083Zm.48 1.27H26v-.3h-1.163v.3Zm1.072-.27-.918.71.183.238.919-.71-.184-.237Zm-.97.872.337 1.129.287-.086-.337-1.129-.287.086Zm.572.967-.918-.71-.184.238.919.71.183-.238Zm-1.099-.711-.918.677.178.241.918-.677-.178-.241Zm-.686.842.337-1.097-.287-.088-.337 1.097.287.088Zm.285-1.26-.918-.71-.184.238.919.71.183-.238Zm-1.01-.44h1.133v-.3H23v.3Zm1.276-.106.367-1.16-.286-.091-.367 1.161.286.09Zm.08-13.164.337 1.161.288-.083-.337-1.162-.288.084Zm.48 1.27H26v-.3h-1.163v.3Zm1.072-.27-.918.71.183.238.919-.71-.184-.237Zm-.97.872.337 1.129.287-.086-.337-1.129-.287.086Zm.572.967-.918-.71-.184.238.919.71.183-.238Zm-1.099-.711-.918.677.178.241.918-.677-.178-.241Zm-.686.842.337-1.097-.287-.088-.337 1.097.287.088Zm.285-1.26-.918-.71-.184.238.919.71.183-.238ZM23 9.312h1.133v-.3H23v.3Zm1.276-.105.367-1.162-.286-.09-.367 1.161.286.09Zm-3.92 3.835.337 1.161.288-.083-.337-1.162-.288.084Zm.48 1.27H22v-.3h-1.163v.3Zm1.072-.27-.918.71.183.238.919-.71-.184-.237Zm-.97.872.337 1.129.287-.086-.337-1.129-.287.086Zm.572.967-.918-.71-.184.238.919.71.183-.238Zm-1.099-.711-.918.677.178.241.918-.677-.178-.241Zm-.686.842.337-1.097-.287-.088-.337 1.097.287.088Zm.285-1.26-.918-.71-.184.238.919.71.183-.238Zm-1.01-.44h1.133v-.3H19v.3Zm1.276-.105.367-1.162-.286-.09-.367 1.161.286.09Z"
    }
  )
), i = v(d)`
  ${l}
  ${t}
`, R = i;
export {
  R as default
};
